import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { ID } from 'src/models';

export const getTeamMembers = (state: RootState) => state.team.members;

export const getTeamInvitedMembers = (state: RootState) => state.team.invitedMembers;

export const getIsFetchedMembersAndInvited = createSelector(
  [getTeamMembers, getTeamInvitedMembers],
  (members, invited) => !!members && !!invited,
);

export const getEitherMembersPresent = (state: RootState) =>
  state.team.members?.length || state.team.invitedMembers?.length;

export const getMembersCount = (state: RootState) =>
  (state.team.members?.length ?? 0) + (state.team.invitedMembers?.length ?? 0);

export const getInputAddedUsers = (state: RootState) => state.team.inputAddedUsers;

export const getInputInvitedUsers = (state: RootState) => state.team.inputInvitedUsers;

export const getShowInputUsers = createSelector(
  [getInputAddedUsers, getInputInvitedUsers],
  (added, invited) => (added?.length ?? 0) + (invited?.length ?? 0),
);

export const getUserRoles = (state: RootState) => (resource_type: string, resource_id: ID) =>
  state.team.roles?.[`${resource_type}::${resource_id}`];

export const getIsShowAll = (state: RootState) => !!state.team.isShowAll;

export const getSearch = (state: RootState) => state.team.search;
